import React, { ChangeEvent, useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Tab,
  TextField,
  Typography,
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";
import galleryIcon from "./../../../../../assets/icons/gallery.png";
import TextAreaComponents from "./../../../../components/TextAreaComponents/TextAreaComponents.tsx";
import jwt_decode from "jwt-decode";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Input } from "@mui/icons-material";
import upload from "./../../../../../assets/icons/cloud-computing.png";
import pending from "./../../../../../assets/icons/pending.png";
import checked from "./../../../../../assets/icons/checked.png";
import LoadingView from "../../../../components/LoadingView/LoadingView.js";

function EditBankDetails(props) {
  const [accountHolderName, setAccountHolderName] = useState(
    props.selectedData.accountHolderName
  );
  const [accountNumber, setAccountNumber] = useState(
    props.selectedData.accountNumber
  );
  const [sortCode, setSortCode] = useState(props.selectedData.sortCode);
  const [iBAN, setIBAN] = useState(props.selectedData.iban);
  const [selectedImages, setSelectedImages] = useState<string[]>([]);
  const [imageFiles, setImageFiles] = useState<File[]>([]);
  const [imageErr, setImageErr] = useState(false);
  const apiAddress = process.env.REACT_APP_SECRET;
  const [userId, setUserId] = useState("");
  const [restaurantId, setRestaurantId] = useState("");
  const Restauranttoken = JSON.parse(localStorage.getItem("restaurant"));
  const [selectedRestaurantDatas, setSelectedRestaurantDatas] = useState([]);
  const [selectedRestaurant, setSelectedRestaurant] = useState();
  const [value, setValue] = useState("1");
  const [CompanyBankStatementFiles, setCompanyBankStatementFiles] = useState(
    []
  );
  const [loadingModal, SetloadingModal] = React.useState(false);
  const [tableData, setTableData] = useState({
    Id: "12233445",
    KycCompanyDetailsId: "",
    Name: "Company Bank Statement",
    Description:
      "Bank statement of the corporate bank account (dated within the last 3 months)",
    File: [],
    Comment: "comment",
  });

  console.log(props.selectedData);

  useEffect(() => {
    const token = localStorage.getItem("gotasteadmintoken");
    if (token) {
      try {
        const decoded = jwt_decode(token);
        setUserId(decoded.UserId);
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
    loadRestaurantName();
  }, []);

  const handleClose = () => {
    props.onHandleAddItem(false);
    // resetForm();
  };

  //   const resetForm = () => {
  //     setCategoryName("");
  //     setSelectedImages([]);
  //     setImageFiles([]);
  //     setImageErr(false);
  //   };

  let submitableOBJ = {
    id: "string",
    restaurantId: "string",
    accountHolderName: "string",
    accountNumber: "string",
    sortCode: "string",
    iban: "string",
    isApproveByAdmin: "f07294b7-c94d-4d5e-a064-b1282d5b543b",
    isActive: true,
    createdBy: "string",
    creationDate: new Date().toISOString(),
    modifierId: "string",
    modificationDate: new Date().toISOString(),
    document: {
      id: "string",
      restaurantBankDetailId: "string",
      name: "Company Bank Statement",
      description:
        "Bank statement of the corporate bank account (dated within the last 3 months)",
      fileUrls: [],
    },
  };

  const handleSubmit = async () => {
    // if (props?.isSubmitting) return;
    // props?.setIsSubmitting(true);

    let valid = true;

    if (
      accountHolderName == "" ||
      accountHolderName == undefined ||
      accountHolderName == null
    ) {
      valid = false;
      toast.error("Account Holder Name is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

    if (
      accountNumber == "" ||
      accountNumber == undefined ||
      accountNumber == null
    ) {
      valid = false;
      toast.error("Account Number is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (sortCode == "" || sortCode == undefined || sortCode == null) {
      valid = false;
      toast.error("Sort Code is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (iBAN == "" || iBAN == undefined || iBAN == null) {
      valid = false;
      // toast.error("IBAN is required", {
      //   position: "top-right",
      //   autoClose: 5000,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "colored",
      // });
      setIBAN("N/A");
    }

    if (valid) {
      try {
        SetloadingModal(true);
        const id = crypto.randomUUID();
        const documentID = crypto.randomUUID();

        submitableOBJ.id = props.selectedData.id;
        submitableOBJ.accountHolderName = accountHolderName;
        submitableOBJ.accountNumber = accountNumber;
        submitableOBJ.sortCode = sortCode;
        submitableOBJ.iban = iBAN;
        submitableOBJ.createdBy = userId;
        submitableOBJ.modifierId = userId;
        submitableOBJ.restaurantId = selectedRestaurantDatas.id;
        submitableOBJ.document.id = documentID;
        submitableOBJ.document.restaurantBankDetailId = id;

        await fileupload(documentID);

        axios({
          method: "put",
          url:
            apiAddress + "/api/RestaurantBankDetails/" + props.selectedData.id,
          data: submitableOBJ,
        }).then((response) => {
          console.log(response);

          toast.success("Successfully Saved", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });

          props?.setIsSubmitting(false);
          handleClose();
          SetloadingModal(false);
        });
      } catch (error) {
        console.error("Error adding category:", error);
        toast.error("Failed to add category", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        SetloadingModal(false);
      }
    }
  };

  const fileupload = async (id) => {
    try {
      const formData = new FormData();

      // Append each file with the same field name "file"
      tableData.File.forEach((file) => {
        formData.append("file", file);
      });

      const response = await axios.post(
        `${apiAddress}/api/FileUpload/addMultiplefile`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Process response and update submitableOBJ
      response.data.forEach((dt) => {
        submitableOBJ.document.fileUrls.push({
          id: crypto.randomUUID(),
          restaurantBankDetailDocumentId: id,
          documentUrl: dt,
        });
      });

      return response.data;
    } catch (error) {
      console.error("File upload error:", error);
      throw error; // Re-throw to handle in calling function
    }
  };

  const [restaurantDatas, setRestaurantDatas] = React.useState([]);

  const token = localStorage.getItem("gotasteadmintoken");

  const loadRestaurantName = () => {
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwt_decode(token);

        setUserId(decodedData.UserId);

        // setTokenData(decodedData)
      } catch (error) {}
    }

    axios
      // .get(apiAddress + "/api/api/RestaurantUserMapper/getbyuseridaAndRestaurantId?userId=" + decodedData.UserId+"&restaurantId="+Restauranttoken.id)
      .get(
        apiAddress +
          `/api/RestaurantUserMapper/getbyuseridaAndRestaurantId?userId=${decodedData.UserId}&restaurantId=${Restauranttoken.id}`
      )
      .then((response) => {
        var list = [];
        response.data.map((dt, i) => {
          var obj = {
            id: dt.restaurantId,
            title: dt.restaurantName,
          };
          list.push(obj);
        });
        setRestaurantDatas(list);
      });
  };

  const [resturentId, setResturentId] = useState("");
  useEffect(() => {
    const foundItem = restaurantDatas.find(
      (item) => item.id === props.selectedData.restaurantId
    );
    setSelectedRestaurant(foundItem);
    setSelectedRestaurantDatas(foundItem);
  }, [restaurantDatas]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const isFileSizeValid = (file, maxSizeInBytes) => {
    if (file && file.size <= maxSizeInBytes) {
      return file;
    }
  };

  // const handleCompanyBankStatementFileChange = (event) => {
  //   alert("hello");
  //   var valid = true;
  //   const files = event.target.files[0];
  //   const maxSizeInBytes = 50 * 1024 * 1024;

  //   if (isFileSizeValid(files, maxSizeInBytes)) {
  //     tableData.File.push(files);
  //     setCompanyBankStatementFiles([
  //       ...CompanyBankStatementFiles,
  //       ...event.target.files,
  //     ]);
  //   } else {
  //     // alert("File size should be less than or equal to 50 MB.");
  //     valid = false;
  //     toast.error("File size should be less than or equal to 50 MB", {
  //       position: "top-right",
  //       autoClose: 5000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //       theme: "colored",
  //     });
  //   }
  // };
  const handleCompanyBankStatementFileChange = (event) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    const maxSizeInBytes = 50 * 1024 * 1024;
    const validFiles = [];
    let hasInvalidFile = false;

    Array.from(files).forEach((file) => {
      if (file.size <= maxSizeInBytes) {
        validFiles.push(file);
      } else {
        hasInvalidFile = true;
      }
    });

    if (hasInvalidFile) {
      toast.error("Some files exceed the 50MB limit", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

    if (validFiles.length > 0) {
      setCompanyBankStatementFiles([
        ...CompanyBankStatementFiles,
        ...validFiles,
      ]);
      setTableData((prev) => ({
        ...prev,
        File: [...prev.File, ...validFiles],
      }));
    }
  };

  // Updated file removal handler
  const handleRemoveFile = (index: number) => {
    const newFiles = [...CompanyBankStatementFiles];
    newFiles.splice(index, 1);
    setCompanyBankStatementFiles(newFiles);
    setTableData((prev) => ({
      ...prev,
      File: newFiles,
    }));
  };
  const closeLoadingModal = () => {
    SetloadingModal(false);
  };
  return (
    <div>
      <LoadingView open={loadingModal} close={closeLoadingModal} />
      <Dialog
        fullWidth={true}
        open={props.open}
        onClose={handleClose}
        maxWidth={"lg"}
      >
        <ToastContainer />
        <DialogTitle>
          <Grid container justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Edit Bank Details</Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ width: "100%", typography: "body1" }}>
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                >
                  <Tab label="Details" value="1" />
                  <Tab label="Documents" value="2" />
                </TabList>
              </Box>

              {/* Bank Account details */}
              <TabPanel value="1" sx={{ padding: "10px" }}>
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <div
                      className="d-flex"
                      style={{ paddingTop: "1rem", gap: "10px" }}
                    >
                      <Typography style={{ paddingTop: "1rem" }}>
                        Restaurant
                      </Typography>
                    </div>
                  </Grid>
                  <Grid item xs={10}>
                    {selectedRestaurant && (
                      <Autocomplete
                        defaultValue={selectedRestaurant}
                        id="restaurant-dropdown"
                        options={restaurantDatas}
                        onChange={(event, newInputValue, reason, detail) => {
                          setSelectedRestaurantDatas(newInputValue);
                        }}
                        className="my-3"
                        getOptionLabel={(option) => option.title}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            label="Restaurant"
                          />
                        )}
                      />
                    )}
                  </Grid>
                </Grid>

                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      Account Holder Name
                    </Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <TextAreaComponents
                      label={"Account Holder Name"}
                      value={setAccountHolderName}
                      val={accountHolderName}
                    ></TextAreaComponents>
                  </Grid>
                </Grid>
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      Account Number
                    </Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <TextAreaComponents
                      label={"Account Number"}
                      value={setAccountNumber}
                      val={accountNumber}
                    ></TextAreaComponents>
                  </Grid>
                </Grid>
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      Sort Code
                    </Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <TextAreaComponents
                      label={"Sort Code"}
                      value={setSortCode}
                      val={sortCode}
                    ></TextAreaComponents>
                  </Grid>
                </Grid>
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>IBAN</Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <TextAreaComponents
                      label={"IBAN"}
                      value={setIBAN}
                      val={iBAN}
                    ></TextAreaComponents>
                  </Grid>
                </Grid>
              </TabPanel>

              {/* Document Sections */}
              <TabPanel value="2" sx={{ padding: "10px" }}>
                <tr>
                  <td style={{ width: "30%" }}>
                    <h6> Company Bank Statement*</h6>
                    <p className="tableDescription">
                      Bank statement of the corporate bank account (dated within
                      the last 3 months)
                    </p>
                  </td>

                  {/* Done / Not Uploaded */}
                  {/* <td style={{ width: "30%" }}>
                    {tableData.File.length != 0 ? (
                      <div className="d-flex">
                        <img
                          src={checked}
                          alt=""
                          style={{ width: "1.5rem", height: "1.5rem" }}
                        />
                        <p style={{ color: "green", marginLeft: "2px" }}>
                          {" "}
                          Done
                        </p>
                      </div>
                    ) : (
                      <div className="d-flex">
                        <img
                          src={pending}
                          alt=""
                          style={{ width: "1.5rem", height: "1.5rem" }}
                        />
                        <p style={{ color: "#cc9840", marginLeft: "2px" }}>
                          {" "}
                          Not uploaded
                        </p>
                      </div>
                    )}
                  </td> */}

                  {/* <td>
                    <div className="pt-3">
                      <Input
                        type="file"
                        onChange={handleCompanyBankStatementFileChange}
                        style={{ display: "none" }}
                        id="CompanyBankStatement-file-uploader"
                      />

                      <label
                        htmlFor="CompanyBankStatement-file-uploader"
                        className="uploadText"
                      >
                        Upload
                        <img
                          src={upload}
                          alt="upload"
                          style={{
                            width: "1.5rem",
                            height: "1.5rem",
                            marginLeft: "2px",
                          }}
                        />
                      </label>

                      {props?.selectedData?.documentObj?.length > 0 ? (
                        <ul className="dotted-border-forfiles d-flex flex-column">
                          {props?.selectedData?.documentObj?.map((url) =>
                            url?.fileUrls?.map((file, index) => (
                              <li key={index} className="d-flex gap-2 text-align-center">
                                <img style={{ width: '20px', height: '20px' }} src={file.documentUrl} alt={`Document ${index}`} />
                                <span>{url.description}</span>
                              </li>
                            ))
                          )}
                        </ul>
                      ) : <h6>No File Found</h6>}

                    </div>
                  </td> */}

                  <td>
                    <div className="pt-3">
                      <input
                        type="file"
                        onChange={handleCompanyBankStatementFileChange}
                        style={{ display: "none" }}
                        id="CompanyBankStatement-file-uploader"
                        accept=".pdf,.doc,.docx,.png,.jpg,.jpeg"
                        multiple // Allow multiple file selection
                      />

                      <label
                        htmlFor="CompanyBankStatement-file-uploader"
                        className="uploadText"
                        style={{ cursor: "pointer" }}
                      >
                        Upload
                        <img
                          src={upload}
                          alt="upload"
                          style={{
                            width: "1.5rem",
                            height: "1.5rem",
                            marginLeft: "2px",
                          }}
                        />
                      </label>

                      {/* Display newly selected files */}
                      {tableData.File.length > 0 && (
                        <ul className="dotted-border-forfiles d-flex flex-column">
                          {tableData.File.map((file, index) => (
                            <li
                              key={index}
                              className="d-flex gap-2 align-items-center"
                            >
                              <span>{file.name}</span>
                              <IconButton
                                size="small"
                                onClick={() => handleRemoveFile(index)}
                              >
                                <CancelIcon fontSize="small" />
                              </IconButton>
                            </li>
                          ))}
                        </ul>
                      )}

                      {/* Display existing files from props */}
                      {props?.selectedData?.documentObj?.length > 0 ? (
                        <ul className="dotted-border-forfiles d-flex flex-column">
                          {props.selectedData.documentObj.map(
                            (document, docIndex) =>
                              document?.fileUrls?.map((file, fileIndex) => {
                                const fileName = file.documentUrl || "Document";
                                const fileDocumentName =
                                  file.documentUrl.split("/").pop() ||
                                  "Document";

                                return (
                                  <li
                                    key={`${docIndex}-${fileIndex}`}
                                    className="d-flex gap-2 align-items-center"
                                  >
                                    <a
                                      href={file.documentUrl}
                                      download={fileDocumentName}
                                      style={{
                                        textDecoration: "underline",
                                        color: "inherit",
                                      }}
                                      onClick={(e) => {
                                        if (
                                          !file.documentUrl.startsWith("blob:")
                                        ) {
                                          e.preventDefault();
                                          window.open(
                                            file.documentUrl,
                                            "_blank"
                                          );
                                        }
                                      }}
                                    >
                                      {/* {fileName} */}
                                      Company Bank Statement
                                    </a>
                                    {/* {document.description && (
                                <span style={{ fontSize: '0.8rem', color: '#666' }}>
                                  ({document.description})
                                </span>
                              )} */}
                                  </li>
                                );
                              })
                          )}
                        </ul>
                      ) : (
                        <h6>No File Found</h6>
                      )}
                    </div>
                  </td>
                </tr>
              </TabPanel>
            </TabContext>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleSubmit}
            color="primary"
            // disabled={props.isSubmitting}
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default EditBankDetails;
